const groupTypes = [
  { groupTypeString: 'Status Solutions', groupTypeEnum: 1 },
  { groupTypeString: 'Corporate', groupTypeEnum: 2},
  { groupTypeString: 'Facility', groupTypeEnum: 3},
  { groupTypeString: 'Family', groupTypeEnum: 4},
]

export default groupTypes;
